import safeLocalStorage from "../../utils/localstorage";

const mutations = {
  ["SET_ENERGY_TOTAL"](state, payload) {
    state.pricing.energy_total = payload;
  },
  ["SET_GAS_TOTAL"](state, payload) {
    state.pricing.gas_total = payload;
  },
  ["SET_CONSUMPTION_STATUS"](state, payload) {
    state.consumption.status = payload;
  },
  ["SET_CONSUMPTION_LIST"](state, payload) {
    state.consumptions = payload;
  },
  ["SET_ELECTRICITY_LOW"](state, payload) {
    state.consumption.electric.double.low = payload;
  },
  ["SET_ELECTRICITY_HIGH"](state, payload) {
    state.consumption.electric.double.high = payload;
  },
  ["SET_ELECTRICITY_SINGLE"](state, payload) {
    state.consumption.electric.single = payload;
  },
  ["SET_ELECTRICITY_SINGLE_LOW"](state, payload) {
    state.consumption.electric.low = payload;
  },
  ["SET_ELECTRICITY_SINGLE_HIGH"](state, payload) {
    state.consumption.electric.high = payload;
  },
  ["SET_GAS"](state, payload) {
    state.consumption.gas = payload;
  },
  ["SET_WATER"](state, payload) {
    state.consumption.water = payload;
  },
  ["CLEAR_WATER"](state) {
    state.consumption.water = {
      m3_monthly: "0",
      monthly_price: "0",
      yearly_price: "0"
    };
  },
  ["SET_STADSWARMTE"](state, payload) {
    state.consumption.stadswarmte = payload;
  },
  ["CLEAR_STADSWARMTE"](state) {
    state.consumption.stadswarmte = {
      m3_monthly: "0",
      monthly_price: "0",
      yearly_price: "0"
    };
  },
  ["SET_FAMILY_SITUATION"](state, payload) {
    state.consumption.familySituation = payload;
  },
  ["SET_INSURANCE_LEAD"](state, payload) {
    if (state.insuranceSelectionsLead.includes(payload)) {
      state.insuranceSelectionsLead.map((id, index) => {
        if (id == payload) {
          state.insuranceSelectionsLead.splice(index, 1);
        }
      });
    } else {
      state.insuranceSelectionsLead.push(payload);
    }
  },
  ["SET_MORTGAGE"](state, payload) {
    state.mortgage = payload;
  },

  ["SET_COLUMN"](state, payload) {
    state.column = payload;
  },
  
  ["SET_FORM_SEARCH_KEY"](state, payload) {
    state.formSearchKey = payload;
  },
  ["SET_TRIGGER"](state, payload) {
    state.trigger = payload;
  },
  ["SET_ADDRESS_RESIDENTIAL"](state, payload) {
    state.addressResidential = payload;

  },

  //internet services and postcode
  ["SET_DISCIPLINECODE"](state, payload) {
    state.disciplinecode = payload;
  },
  ["SET_EDIT"](state, payload) {
    state.edit = payload;
  },
  ["SET_POSTCODE"](state, payload) {
    state.postcodeQuery = payload;
  },
  ["SET_POSTCODE_WIDGET"](state, payload) {
    state.number_addition = payload;
  },
  ["SET_SUPPLIER_CHECK"](state, payload) {
    state.postcodeQuery = payload;
  },
  ["SET_ZIGGO"](state, payload) {
    state.checkZiggo = payload;
  },
  ["SET_YOUFONE"](state, payload) {
    state.checkYoufone = payload;
  },
  ["CLEAR_INTERNET_SERVICES"](state) {
    state.checkYoufone = null;
    state.checkKpn = null;
    state.checkZiggo = null;
    state.checkTmobile = null;
  },
  ["CLEAR_INTERNET_OVERVİEW"](state) {
    if (state.overview.filter(x => x.id === 4).length > 0) {
      state.overview.filter(a => a.id === 4)[0].packagestotal = 0;
      state.overview.filter(a => a.id === 4)[0].yearly = 0;
      state.overview.filter(a => a.id === 4)[0].packages = [];
      state.overview.filter(a => a.id === 4)[0].discountTotal = 0;
      state.overview.filter(a => a.id === 4)[0].discounts = [];
    }
  },
  ["CLEAR_DISCIPLINECODE"](state) {
    state.disciplinecode = null;
  },
  ["SET_TMOBILE"](state, payload) {
    state.checkTmobile = payload;
  },
  ["SET_KPN"](state, payload) {
    state.checkKpn = payload;
  },
  ["SET_CLONED_FORM"]() {
    console.log("cloned");
  },

  //submit data
  ["SET_FORMDATA"](state, payload) {
    state.SubmitData = {
      form_id: payload.data.id,
      consumption: payload.data.consumption,
      products: payload.data.products,
      start_date: payload.data.start_date,
      widgets: payload.data.widgets,
      start_date_status: payload.data.start_date_status,
      customertype: payload.data.customer_type,
      language: payload.data.language || "en"
    };
    if (
      payload.data.products &&
      payload.data.products.electricity &&
      payload.data.products.electricity.solar
    ) {
      state.solar.status = payload.data.products.electricity.solar.status;
      state.solar.kwhKnown = payload.data.products.electricity.solar.kwhKnown;
      state.solar.number_of_panels = parseInt(
        payload.data.products.electricity.solar.number_of_panels
      );
      state.solar.low =
        payload.data.products.electricity.solar.return_delivery_low_kwh;
      state.solar.high =
        payload.data.products.electricity.solar.return_delivery_normal_kwh;
      state.solar.single =
        payload.data.products.electricity.solar.return_delivery_kwh;
    }
    //consumption
    if (payload.data.consumption) {
      state.consumption.familySituation =
        parseInt(payload.data.consumption.family_situation) ??
        state.consumption.familySituation;
    }
    if (
      payload.data.products &&
      payload.data.products.electricity &&
      payload.data.products.electricity.consumption
    ) {
      state.consumption.status =
        payload.data.consumption.status ?? state.consumption.status;
      state.consumption.familySituation =
        parseInt(payload.data.consumption.family_situation) ??
        state.consumption.familySituation;

      state.consumption.electric.single =
        payload.data.products.electricity.consumption.single ??
        state.consumption.electric.single;

        //If smart meter is double meter
      if (payload.data.products.electricity.meter == "2") {
        state.consumption.electric.double.low =
        payload.data.products.electricity.consumption.double.low ??
        state.consumption.electric.double.low;
       state.consumption.electric.double.high =
        payload.data.products.electricity.consumption.double.high ??
        state.consumption.electric.double.high;
      } else {
        state.consumption.electric.low =
        payload.data.products.electricity.consumption.low ??
        state.consumption.electric.low;
       state.consumption.electric.high =
        payload.data.products.electricity.consumption.high ??
        state.consumption.electric.high;
      }
     
    }

    if (payload.data.products && payload.data.products.gas) {
      if (payload.data.isLead === "false") {
        state.consumption.status =
          payload.data.consumption.status ?? state.consumption.status;
        state.consumption.familySituation =
          parseInt(payload.data.consumption.family_situation) ??
          state.consumption.familySituation;
        state.consumption.gas =
          payload.data.products.gas.consumption ?? state.consumption.gas;
      }
    }

    if (
      payload.data.products &&
      payload.data.products.water &&
      payload.data.consumption
    ) {
      state.consumption.familySituation =
        parseInt(payload.data.consumption.family_situation) ??
        state.consumption.familySituation;
    }

    if (
      payload.data.products &&
      payload.data.products.stadswarmte &&
      payload.data.consumption
    ) {
      state.consumption.familySituation =
        parseInt(payload.data.consumption.family_situation) ??
        state.consumption.familySituation;
    }

    if (payload.data.products && payload.data.products.electricity) {
      state.meter = payload.data.products.electricity.meter ?? state.meter;
    }

    //dates
    state.startDateStatus = payload.data.start_date_status;
    state.generalDate = payload.data.start_date;

    if (state.SubmitData.products) {
      for (const [key, value] of Object.entries(state.SubmitData.products)) {
        if (value.start_date) {
          if (key === "electricityandgas") {
            state.electricGasDate = value.start_date;
          }
          state.lookUpDate.push({ key, value: value.start_date });
        }
      }
    }

    //postcode number-addition
    if (
      payload.data.widgets &&
      payload.data.widgets.address &&
      payload.data.widgets.address.number_addition
    ) {
      state.postcode.numberAddition =
        payload.data.widgets.address.number_addition;
    }
  },
  ["CLEAR_SUBMIT_DATA"](state) {
    state.SubmitData = {
      widgets: {
        address: {}
      },
      products: {}
    };
  },

  //solar
  ["SET_SOLAR_LIST"](state, payload) {
    state.solars = payload;
  },
  ["SET_SOLAR_PANELS"](state, payload) {
    state.solar.number_of_panels = payload;
  },
  ["SET_SOLAR_SINGLE"](state, payload) {
    state.solar.single = payload;
  },
  ["SET_SOLAR_LOW"](state, payload) {
    state.solar.low = payload;
  },
  ["SET_SOLAR_HIGH"](state, payload) {
    state.solar.high = payload;
  },
  ["SET_SOLAR_STATUS"](state, payload) {
    state.solar.status = payload;
  },
  ["SET_KWHKNOWN_STATUS"](state, payload) {
    state.solar.kwhKnown = payload;
  },

  //date widget
  ["SET_STARTDATE_STATUS"](state, payload) {
    state.startDateStatus = payload;
  },
  ["SET_GENERAL_DATE"](state, payload) {
    state.generalDate = payload;
  },
  ["SET_ELECTRICGAS_DATE"](state, payload) {
    state.electricGasDate = payload;
  },

  ///others
  ["SET_MODAL_CONTENT_COMPUTED"](state, payload) {
    state.modalContentAsComputed = payload;
  },
  ["SET_FORMS"](state, payload) {
    state.AllForms = payload;
  },
  ["SET_MULTIPLE_FORMS"](state, payload) {
    state.multipleForms = payload;
  },
  ["SET_SUBMITS"](state, payload) {
    state.AllSubmits = payload;
  },
  ["SET_TOKEN"](state, payload) {
    safeLocalStorage.setItem("arx.token", payload);
  },
  ["SET_USER"](state, payload) {
    safeLocalStorage.setItem("user", payload);
  },
  ["SET_CLIENTS"](state, payload) {
    state.clients = payload;
  },
  ["SET_NATIONALITY"](state, payload) {
    state.nationalities = payload;
  },
  ["SET_DURATIONS"](state, payload) {
    state.durations = payload;
  },
  ["SET_SUPPLIER_DATA"](state, payload) {
    state.supplierdata = payload;
  },
  ["SET_DRAFTID"](state, payload) {
    state.draftID = payload[1].data.data.id;
  },
  ["SET_LANG"](state, payload) {
    state.lang = payload;
  },
  ["SET_FORMSUCCESS"](state, payload) {
    state.formsuccess = payload;
  },
  ["SET_LEADFORCED"](state, payload) {
    state.leadforced = payload;
  },
  ["SET_FORM"](state, payload) {
    state.formStateData = { ...payload }.data;
    state.lang =
      payload.data.data.language === "multi"
        ? "en"
        : payload.data.data.language;
    state.selectedProducts = [];
  },
  ["CLEAR_ITEM_SHOW"](state) {
    state.itemIsShow = [];
  },
  ["SET_RATES"](state, payload) {
    state.rates = payload;
  },
  ["RATES_LOADER"](state, payload) {
    state.ratesloader = payload;
  },
  ["SET_METER"](state, payload) {
    state.meter = payload;
  },
  ["SET_SMART_METER"](state, payload) {
    state.smartMeter = payload;
  },
  ["RESET_OVERVIEW"](state) {
    state.overview = [];
  },
  ["DELETE_FORM"]() {
    console.log("deleted");
  },
  ["DELETE_OVERVIEW_ELEMENT"](state) {
    if (state.overview.filter(a => a.id === 4).length > 0) {
      state.overview.filter(a => a.id === 4)[0].packagestotal = 0;
      state.overview.filter(a => a.id === 4)[0].yearly = 0;
      state.overview.filter(a => a.id === 4)[0].packages = [];
      state.overview.filter(a => a.id === 4)[0].discountTotal = 0;
      state.overview.filter(a => a.id === 4)[0].discounts = [];
      // state.overview.splice(state.overview.findIndex(v => v.id === 4), 1);
    }
  },
  ["CLEAR_FORM"](state) {
    state.formStateData = {
      data: {
        fields: [
          {
            id: 1,
            group: "sections",
            type: "products",
            title: "",
            description: {},
            css: "",
            products: [],
            defaultProducts: []
          }
        ]
      }
    };
  }
};

export default mutations;
